import { css } from '@emotion/react'
import {
  RadiusToken,
  SpacingToken,
} from '@livechat/design-system-react-components'

import mediaQueries from '@/layout/media-queries'

const styles = {
  autocomplete:
    (show, displayAAVersion) =>
    ({ colors }) =>
      css`
        display: flex;
        align-items: center;
        position: relative;
        ${displayAAVersion && `flex-grow: 1;`}

        > span:has(> svg) {
          position: ${show ? 'absolute' : 'relative'};
          left: ${show ? '10px' : 0};
          cursor: pointer;
          z-index: 15;

          &:hover {
            > path {
              fill: ${colors.blue600};
            }
          }
        }

        .search-close-icon {
          ${!show && `display: none;`}
          fill: ${colors.gray600};
          right: 10px;
          left: auto;
        }

        ${show &&
        displayAAVersion &&
        `
        > span:first-of-type:has(> svg) {
            display: none;
        }`}
      `,
  input: (show, displayAAVersion) =>
    css`
      margin: 0;
      overflow-x: hidden;
      transition: width 0.3s ease, opacity 0.2s ease;
      ${!show && displayAAVersion && `transition: none;`}
      will-change: width, opacity;
      width: 100%;

      ${!show &&
      `
      opacity: 0;
      border: none;
      padding: 0;
      width: 0px;
      `}

      ${mediaQueries.mediumScreen(100)} {
        width: ${show ? '220px' : '0px'};
      }

      > input {
        padding-left: var(${SpacingToken.Spacing7});
        appearance: none;
      }

      ${show &&
      displayAAVersion &&
      `
        > input {
          padding-left: 0px;
          padding-right: var(${SpacingToken.Spacing7});
        }`}
    `,
  results:
    (isMoreResultsBtnVisible) =>
    ({ colors }) =>
      css`
        width: 90vw;
        position: fixed;
        top: 65px;
        left: 5vw;
        margin-top: 5px;

        ${mediaQueries.mediumScreen(100)} {
          position: absolute;
          top: 100%;
          width: 160%;
          left: 0;
        }

        background-color: ${colors.white};
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
        z-index: 100000;
        border-radius: var(${RadiusToken.Radius1});
        padding-top: 15px;
        padding-bottom: ${isMoreResultsBtnVisible ? '0' : '15px'};

        .autocomplete-list {
          margin: 0;
          padding: 0;
          overflow-y: auto;
        }

        .autocomplete-item {
          display: flex;

          &__link {
            display: flex;
            align-items: center;
            padding: 10px 15px;
            text-decoration: none;
            width: 100%;

            > img,
            > svg {
              width: 40px;
              height: 40px;
              border-radius: var(${RadiusToken.Radius1});
              object-fit: contain;
              border: 1px solid ${colors.iron};
              background-color: ${colors.white};
            }
          }

          &__info {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            height: 40px;
          }

          &__name,
          &__category {
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            white-space: nowrap;

            ${mediaQueries.smallScreen()} {
              max-width: 270px;
            }
          }

          &__name {
            line-height: 26px;
            font-size: 16px;
            font-weight: 500;
            color: ${colors.black};
          }

          &__category {
            font-weight: 400;
            font-size: 12px;
            letter-spacing: 0.02em;
            color: ${colors.primaryAlpha(0.7)};
          }
        }
      `,
}

export default styles
